import styled from 'styled-components';
import { styledHeader, Typography } from './BaseTypes';
import { styledMargin } from '../layout/Margin';

export const H6 = styled.h6<Typography>`
  ${styledHeader}
  ${styledMargin}
  font-size: 16px;
`;
